module.exports = __webpack_public_path__ + "static/media/combined-shape.caaf2597.svg";